import React from 'react'
import { API, graphqlOperation } from 'aws-amplify'
import { useSelector } from 'react-redux'
import { Auth } from 'aws-amplify'
import { StorageService } from '../../../lib/StorageService'
import Button from 'antd/lib/button'

const styles = {
    buttonContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
}

const op = `mutation CreateTenantAcknowledgements($input: tenantAcknowledgementsInput){
    createTenantAcknowledgements(input: $input) {
            pk
            sk
            d1
            building
            tenant
            acknowledgements {
                active
                declined
                timestamp
                acknowledgedBy {
                    firstName
                    lastName
                    email
                }
            }
    }
}`

const AcknowledgeForm = ({ callback }) => {
    const tenant = useSelector((state) => state.app.tenant)
    const building = useSelector((state) => state.app.building)
    const user = useSelector((state) => state.app.user)

    const mutateAcknowledgement = async (declined) => {
        let data = {
            pk: tenant.pk,
            sk: 'TENANT_ACKNOWLEDGEMENTS',
            d1: tenant.d1,
            tenant: tenant.name,
            building: building.name,
            acknowledgements: [
                {
                    acknowledgedBy: {
                        email: user.email,
                        firstName: user.firstName,
                        lastName: user.firstName,
                        pk: user.pk,
                    },
                    active: declined ? false : true,
                    timestamp: Date.now(),
                },
            ],
        }

        if (declined) {
            data.acknowledgements[0].declined = true
        }

        let response
        try {
            response = await API.graphql(graphqlOperation(op, { input: data }))
        } catch (e) {
            response = e
        }
        callback(false)
        return response
    }

    const declineAcknowledgement = async () => {
        let response
        try {
            response = await mutateAcknowledgement(true)
            Auth.signOut()
                .then(() => {
                    StorageService.clearData()
                    window.location.reload()
                })
                .catch((err) => console.log(err))
        } catch (e) {
            response = e
        }
    }

    return (
        <div>
            <p>Acknowledgement of Receipt</p>

            <p>By clicking on the accept button I agree that:</p>

            <p>
                1. I am acknowledging receipt of the BSS Online Emergency Training Programs provided
                by building management to help enhance the safety of building occupants.
            </p>

            <p>
                2. I will disseminate this information, The Occupant Life Safety Training Program,
                to my company employees so they can take this training.
            </p>
            <div style={styles.buttonContainer}>
                <Button type="danger" onClick={() => declineAcknowledgement()}>
                    Decline
                </Button>
                <Button type="primary" onClick={() => mutateAcknowledgement(false)}>
                    Accept
                </Button>
            </div>
        </div>
    )
}

export default AcknowledgeForm
